import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Office = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="office icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6C13.6568 6 15 4.65685 15 3C15 1.34315 13.6568 0 12 0C10.3431 0 8.99998 1.34315 8.99998 3C8.99998 4.65685 10.3431 6 12 6ZM8.5 7.00014C7.39543 7.00014 6.5 7.89557 6.5 9.00014V12H2V24H10.9758L11 24.0001H13L13.0242 24H22V12H17.5V9.00014C17.5 7.89557 16.6046 7.00014 15.5 7.00014H8.5ZM11 15V17H9V19H11V21H13V19H15V17H13V15H11Z"
    />
  </svg>
)
